
export interface InteractionHotspot{
    position: any;
    type: string;
}


export class MeetingSyncVo{
    selectedPanoramaIndex: number = -1;
    selectedPanoramaPosition: {x:number,y:number} = null;
    selectedMonumentIndex: number = -1;
    selectedFilePath: string;
    selectedMonumentView: any;
    interactionHotspots: InteractionHotspot[] = []
}